import { createTranslationMessages } from '@backstage/frontend-plugin-api';
import { TranslationBlueprint } from '@backstage/plugin-app-react';
import { userSettingsTranslationRef } from '@backstage/plugin-user-settings';

/**
 * Every Configurações text in pt-BR (Story 2.3, AC-18): the stock rows of
 * Provedores de autenticação and Feature flags, the stock menu and toggles,
 * and the labels the app's Geral cards read from the plugin.
 */
export const userSettingsMessages = TranslationBlueprint.make({
  name: 'byx-user-settings',
  params: {
    resource: createTranslationMessages({
      ref: userSettingsTranslationRef,
      messages: {
        'languageToggle.title': 'Idioma',
        'languageToggle.description': 'Mude o idioma da interface',
        'languageToggle.select': 'Selecionar o idioma {{language}}',
        'themeToggle.title': 'Tema',
        'themeToggle.description': 'Escolha o tema da interface',
        'themeToggle.select': 'Selecionar o tema {{theme}}',
        'themeToggle.selectAuto': 'Selecionar o tema automático',
        'themeToggle.names.light': 'Claro',
        'themeToggle.names.dark': 'Escuro',
        'themeToggle.names.auto': 'Automático',
        'signOutMenu.title': 'Sair',
        'signOutMenu.moreIconTitle': 'Mais opções do perfil',
        'pinToggle.title': 'Fixar menu lateral',
        'pinToggle.description': 'Impede que o menu lateral recolha',
        'pinToggle.switchTitles.unpin': 'Soltar o menu lateral',
        'pinToggle.switchTitles.pin': 'Fixar o menu lateral',
        'pinToggle.ariaLabelTitle': 'Fixar menu lateral',
        'identityCard.title': 'Identidade',
        'identityCard.noIdentityTitle': 'Sem identidade no portal',
        'identityCard.userEntity': 'Usuário',
        'identityCard.ownershipEntities': 'Pertence a',
        'defaultProviderSettings.description':
          'Autentica nas APIs e identidades do {{provider}}',
        'emptyProviders.title': 'Nenhum provedor de autenticação',
        'emptyProviders.description':
          'Provedores de autenticação adicionados ao portal permitem que você se autentique com eles.',
        'emptyProviders.action.title':
          'Abra o app-config.yaml e faça as mudanças destacadas abaixo:',
        'emptyProviders.action.readMoreButtonTitle': 'Saiba mais',
        'providerSettingsItem.title.signIn': 'Entrar no {{title}}',
        'providerSettingsItem.title.signOut': 'Sair do {{title}}',
        'providerSettingsItem.buttonTitle.signIn': 'Entrar',
        'providerSettingsItem.buttonTitle.signOut': 'Sair',
        'authProviders.title': 'Provedores disponíveis',
        'defaultSettingsPage.tabsTitle.general': 'Geral',
        'defaultSettingsPage.tabsTitle.authProviders':
          'Provedores de autenticação',
        'defaultSettingsPage.tabsTitle.featureFlags': 'Feature flags',
        'featureFlags.title': 'Feature flags',
        'featureFlags.description':
          'Atualize a página depois de ligar ou desligar uma feature flag',
        'featureFlags.emptyFlags.title': 'Nenhuma feature flag registrada.',
        'featureFlags.emptyFlags.description':
          'Com feature flags, os plugins registram funções que cada pessoa pode ativar, por exemplo para testes A/B manuais.',
        'featureFlags.emptyFlags.action.title':
          'Um exemplo de como adicionar uma feature flag está destacado abaixo:',
        'featureFlags.emptyFlags.action.readMoreButtonTitle': 'Saiba mais',
        'featureFlags.filterTitle': 'Filtrar',
        'featureFlags.clearFilter': 'Limpar o filtro',
        'featureFlags.flagItem.title.disable': 'Desativar',
        'featureFlags.flagItem.title.enable': 'Ativar',
        'featureFlags.flagItem.subtitle.registeredInApplication':
          'Registrada na aplicação',
        'featureFlags.flagItem.subtitle.registeredInPlugin':
          'Registrada no plugin {{pluginId}}',
        'settingsLayout.title': 'Configurações',
        sidebarTitle: 'Configurações',
        'profileCard.title': 'Perfil',
        'appearanceCard.title': 'Aparência',
      },
    }),
  },
});
